module.exports = __webpack_public_path__ + "static/media/dashuju.88c3b835.png";